import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enGB from "./json/en-GB.json";
import enUS from "./json/en-US.json";
import deAT from "./json/de-AT.json";
import deDE from "./json/de-DE.json";
import frFR from "./json/fr-FR.json";
import jaJP from "./json/ja-JP.json";
import koKR from "./json/ko-KR.json";
import ptBR from "./json/pt-BR.json";
import esMX from "./json/es-MX.json";

i18n.use(initReactI18next).init({
  resources: {
    "en-GB": {
      common: enGB
    },
    "en-US": {
      common: enUS
    },
    "de-AT": {
      common: deAT
    },
    "de-DE": {
      common: deDE
    },
    "fr-FR": {
      common: frFR
    },
    "ja-JP": {
      common: jaJP
    },
    "ko-KR": {
      common: koKR
    },
    "pt-BR": {
      common: ptBR
    },
    "es-MX": {
      common: esMX
    }
  },
  lng: "en-GB",
  fallbackLng: "en-GB",
  react: {
    useSuspense: false
  },
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
